module.exports = __webpack_public_path__ + "img/zaro.c9e3c3d8.svg";